var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalsystemsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.174,
    height: 57.62,
    viewBox: "0 0 64.174 57.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Total_systems_icon",
    x: 0,
    y: 0,
    width: 64.174,
    height: 57.62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_systems_icon-2",
    "data-name": "Total systems icon",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Total_systems_icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Total_systems_icon-3",
    "data-name": "Total systems icon",
    d: "M-172.63,371.871V426.3h32.941V371.871Zm13.691,40.429h-7.354v-7.353h7.354Zm0-12.665h-7.354v-7.353h7.354Zm0-12.665h-7.354v-7.354h7.354Zm12.714,25.329h-7.354v-7.353h7.354Zm0-12.665h-7.354v-7.353h7.354Zm0-12.665h-7.354v-7.354h7.354Zm34.769,10.54v28.98h-7.678V411.207H-130.6v15.284h-7.678v-28.98Zm0-5.336h-26.82v4.037h26.82Z",
    transform: "translate(174.13 -371.37)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalsystemsicon);
export default __webpack_public_path__ + "static/media/Total systems icon.d0fd807e3688ab920ff8197bc7a1de06.svg";
export { ForwardRef as ReactComponent };